'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var formPlaceholders = (0, _reactIntl.defineMessages)({
    asAppearsPassport: {
        'id': 'formPlaceholders.asAppearsPassport',
        'defaultMessage': 'As it appears on your passport'
    },
    generalSelect: {
        'id': 'formPlaceholders.generalSelect',
        'defaultMessage': 'Select...'
    },
    searching: {
        'id': 'formPlaceholders.searching',
        'defaultMessage': 'Searching...'
    },
    searchPrompt: {
        'id': 'formPlaceholders.searchPrompt',
        'defaultMessage': 'Type to search'
    },
    noResultsText: {
        'id': 'formPlaceholders.noResultsText',
        'defaultMessage': 'No results found'
    },
    nationality: {
        'id': 'formPlaceholders.nationality',
        'defaultMessage': 'Nationality'
    },
    selectNationality: {
        'id': 'formPlaceholders.selectNationality',
        'defaultMessage': 'Select a nationality'
    },
    dateFormat: {
        'id': 'formPlaceholders.dateFormat',
        'defaultMessage': 'yyyy-mm-dd'
    },
    airline: {
        'id': 'formPlaceholders.airline',
        'defaultMessage': 'XX (e.g. "AC" for Air Canada)'
    },
    flightNumber: {
        'id': 'formPlaceholders.flightNumber',
        'defaultMessage': '123'
    },
    departureAirport: {
        'id': 'formPlaceholders.departureAirport',
        'defaultMessage': 'ABC (e.g. "YYZ" for Lester B. Pearson)'
    }
}); /**
    *  formPlaceholders is in MessageDescriptorMap format for react-intl:
    *
    *    type MessageDescriptor = {
    *        id: string,
    *        defaultMessage: string,
    *        description?: string,
    *    };
    *
    *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
    */

exports.default = formPlaceholders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formPlaceholders.js
// module id = 1390
// module chunks = 0